// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");

function evt2str(strConsumer) {
  return function (evt) {
    var target = evt.target;
    var str = target.value;
    if (str == null) {
      console.error("target", target);
      return Js_exn.raiseError("evt2str: cannot get 'value' property on the event target.");
    } else {
      return strConsumer(str);
    }
  };
}

function evt2bool(boolConsumer) {
  return function (evt) {
    var target = evt.target;
    var bool = target.checked;
    if (bool == null) {
      console.error("target", target);
      return Js_exn.raiseError("evt2bool: cannot get 'checked' property on the event target.");
    } else {
      return boolConsumer(bool);
    }
  };
}

function evt2click(clickConsumer) {
  return function (evt) {
    clickConsumer({
          ctrl: evt.ctrlKey,
          alt: evt.altKey,
          shift: evt.shiftKey,
          left: evt.button === 0,
          middle: evt.button === 1,
          right: evt.button === 2
        });
  };
}

exports.evt2str = evt2str;
exports.evt2bool = evt2bool;
exports.evt2click = evt2click;
/* No side effect */
